import React, {useState, useEffect} from "react"
import styled from "styled-components"
import _ from "lodash"

import ConfirmationModal from "components/modal/confirmation-modal"
import { InputText_s } from "styles/input-styles"
import DropdownInput from "components/inputs/dropdown"
import { Colors, Label_s } from 'styles/app-styles'

import propertyService, { PropertyType } from "data/property"
import socketService, * as eventType from "data/socket"

import toggles from 'feature-toggles'
import { local } from 'data/lib/local-json'
import Client from 'data/_client'
import { tryParseFloat } from "data/lib/numbers"
import { CapButton_s } from "components/market-lease/market-lease-styles"

const NewNewPropFormContainer = styled.div`
  & > div {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  input{
    margin-left: 8px;
    flex-grow: 1;
  }
  input.property-create-helper{
    width: 143px;
    flex-grow: unset;
  }
  label.property-create-helper{
    flex-grow: 1;
  }
  input[type=radio] {
    margin-right: 5px;
  }
  select {
    width: 234px;
  }
  label {
    margin-bottom: 0px;
  }
  .disabled {
    opacity: 0.5;
  }
  .type-radio-group {
    border: 1px solid ${Colors.heatherGrey};
    padding: 3px;
    padding-right: 8px;
    border-radius: 2px;
  }
  .type-radio-group.with-hospitality {
    border: 1px solid ${Colors.heatherGrey};
    padding: 3px;
    padding-right: 8px;
    border-radius: 2px;
    flex-direction: column;
    align-items: start;
  }
`

const NewPropertyModal = (props: {show: boolean, close: Function, cb?: Function}) => {
  const [code, setCode] = useState<string>("")
  const [area, setArea] = useState<number|undefined>()
  const [units, setUnits] = useState<number|undefined>()
  const [inflation, setInflation] = useState<number|undefined>()
  const [err, setErr] = useState<null | string>(null)
  const [method, setMethod] = useState<string>("new")
  const [template, setTemplate] = useState<null|string>()
  const [templates, setTemplates] = useState()
  const [type, setType] = useState<PropertyType>("Commercial")
  const [defaultType, setDefaultType] = useState<PropertyType>()

  useEffect(() => {
    (async () => {
      const res = await Client.get('folder?select=folderid&code=eq.*Template&parentfolder=is.null')
      const folderid = _.get(res, "[0].folderid")
      if(!folderid) return
      const templates = await Client.get(`property?select=code,propertyid&folderid=eq.${folderid}`)
      setTemplates(_.map(templates, ({propertyid,code})=> ({propertyid,code})))
    })();

    (async () => {
      const defaultPropertyType = _.get(await Client.get('organization'), '0.organizationdetail.defaultPropertyType')
      if (defaultPropertyType) {
        setType(defaultPropertyType)
        setDefaultType(defaultPropertyType)
      }
    })();
  }, [])

  useEffect(() => {
    method != 'from-template' && setTemplate(null)
  }, [method])


  const resetDefaults = () => {
    setType(defaultType!)
    setCode("")
    setErr(null)
    setArea(undefined)
    setUnits(undefined)
    setInflation(undefined)
  }

  const number_rgx = /^Backspace|[\d,.]$/
  const keyfilter = (regexp) => (e) => {
    if(!regexp.test(e.key)){
      e.preventDefault(); e.stopPropagation()
    }
  }

  if(props.show) {
    return (
    <ConfirmationModal
      height={150 + (toggles.propertyTemplates() ? 65 : 0) + (toggles.displayHospitality() ? 35 : 0) + (toggles.displayPropertyCreateHelpers() ? 100 : 0)}
      width={335}
      contentHeight={180 + (toggles.propertyTemplates() ? 65 : 0) + (toggles.displayHospitality() ? 35 : 0) + (toggles.displayPropertyCreateHelpers() ? 100 : 0)}
      show={props.show}
      toggleShow={() => { resetDefaults(); props.close() }}
      title={"Add New Property"}
      confirmText={"Submit"}
      message={""}
      confirmFunc={() => {
        const folderId =  _.last(local('folderPath'))
        propertyService.isCodeUnique(folderId, code)
          .then(unique => {
            if (!code) return setErr("Please enter a unique code")
            if (!unique) return setErr("This code has already been used")
            if(method == 'new') {
              propertyService.createProperty(folderId, type, {code, area, inflation, units})
                .then(res => props.cb && props.cb(res))
            } else if (method == 'from-template' && template) {
              propertyService.copyProperty(parseInt(template), folderId, code, area)
              socketService.newEvent({eventType: eventType.PROPERTY_CREATED_FROM_TEMPLATE, event: null})
            }
            resetDefaults()
            props.close()
          })
      }}
      cancelFunc={() => { resetDefaults(); props.close() }}
      confirmOnly={false}
      closeOnly={false}>

        <NewNewPropFormContainer>
          <div>
            <Label_s htmlFor="code">Property Code</Label_s>
            <InputText_s type="text" name="code" className="automated" value={code} onKeyDown={keyfilter(/^[^*]*$/)} onChange={e => setCode(e.target.value)}/>
          </div>
          { toggles.propertyTemplates() &&
            <div>
              <Label_s>Method</Label_s>
              <DropdownInput
                className={_.isEmpty(templates) ? "" : " automated"}
                disabled={_.isEmpty(templates)}
                persist={(_field, val) => setMethod(val)}
                options={[{label: 'Add New', value: 'new'}, {label: 'Copy From Template', value: 'from-template'}]}
                value={method}
              />
            </div>
          }
          { toggles.propertyTemplates() &&
            <div>
              <Label_s className={method == 'new' ? 'disabled' : ''}>Template</Label_s>
              <DropdownInput
                className={method == 'new' ? "" : " automated"}
                disabled={method == 'new'}
                persist={(_field, val) => setTemplate(val)}
                options={_.map(templates, p => ({label: p.code, value: p.propertyid}))}
                value={template}
              />
            </div>
          }
          <div className={"type-radio-group" + (method != 'new' ? ' disabled' : '') + (toggles.displayHospitality() ? ' with-hospitality' : '')}>
            <Label_s htmlFor="type-commercial">
              <input
                checked={type == 'Commercial'}
                className={method == 'new' ? "automated" : ""}
                disabled={method == 'from-template'}
                id="type-commercial"
                name="type"
                onClick={() => setType('Commercial')}
                type="radio"
                value="Commercial"
              />
              Commercial
            </Label_s>
            {toggles.displayMixedUse() &&
              <Label_s htmlFor="type-mixed-use">
                <input
                  checked={type == 'Mixed-Use'}
                  className={method == 'new' ? "automated" : ""}
                  disabled={method == 'from-template'}
                  id="type-mixed-use"
                  name="type"
                  onClick={() => setType('Mixed-Use')}
                  type="radio"
                  value="Mixed-Use"
                />
                Mixed-Use
              </Label_s>
            }
            <Label_s htmlFor="type-multifamily">
              <input
                checked={type == 'Multifamily'}
                className={method == 'new' ? "automated" : ""}
                disabled={method == 'from-template'}
                id="type-multifamily"
                name="type"
                onClick={() => setType('Multifamily')}
                type="radio"
                value="Multifamily"
              />
              Multifamily
            </Label_s>
            { toggles.displayHospitality() && <Label_s htmlFor="type-hospitality">
              <input
                checked={type == 'Hospitality'}
                className={method == 'new' ? "automated" : ""}
                disabled={method == 'from-template'}
                id="type-hospitality"
                name="type"
                onClick={() => setType('Hospitality')}
                type="radio"
                value="Hospitality"
              />
              Hospitality
            </Label_s>
            }
          </div>
          { toggles.displayPropertyCreateHelpers() &&
            <div>
              <Label_s htmlFor="area" className="property-create-helper">Total Property Area</Label_s>
              <InputText_s type="text" name="area" className="automated property-create-helper" value={area} onKeyDown={keyfilter(number_rgx)} onChange={e => setArea(e.target.value)} onBlur={() => area && setArea(tryParseFloat(area,2))}/>
            </div>
          }
          { toggles.displayPropertyCreateHelpers() &&
            <div>
              <Label_s htmlFor="units" className="property-create-helper">Total Units/Rooms</Label_s>
              <InputText_s type="text" disabled={method != 'new' || type == 'Commercial'} name="units" className="automated property-create-helper" value={units} onKeyDown={keyfilter(number_rgx)} onChange={e => setUnits(e.target.value)} onBlur={() => units && setUnits(tryParseFloat(units))}/>
            </div>
          }
          { toggles.displayPropertyCreateHelpers() &&
            <div>
              <Label_s htmlFor="inflation" className="property-create-helper">Default Inflation %</Label_s>
              <InputText_s type="text" disabled={method != 'new'} name="inflation" className="automated property-create-helper" value={inflation} onKeyDown={keyfilter(number_rgx)} onChange={e => setInflation(e.target.value)} onBlur={() => inflation && setInflation(tryParseFloat(inflation,5))}/>
            </div>
          }
        </NewNewPropFormContainer>
        <div>
          {err ? <label style={{color: "red"}}>{err}</label> : null}
        </div>
    </ConfirmationModal>
  )} else return null
}

export default NewPropertyModal
